/* file description */
import * as React from 'react';
import { useEffect, useState, useRef, useMemo } from 'react';
import { Button } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import useMetaStore from '@/store/useMetaStore';
import SpBusinessBtns from '@/components/sp-business-btns';
import TopTableBtns from './TopTableBtns';
import { FreeBtnClickProps } from '../effect/useFreeBtnClick';
import useValuesStore from '@/store/useValuesStore';
import { SPTableListPropsType } from '../type';
import RuleController from '@/components/RuleController';
import { TableRowSelectType } from '@/const';

interface ToolBarRenderProps extends SPTableListPropsType {
  moduleId: string;
  config: any;
  addTableData: (moduleCode: string, addValues?: any) => void;
  addTableDataList: (moduleCode: string, addValuesList?: any) => void;
  freeButtonClick: ({ btnInfo, open }: FreeBtnClickProps, ctx?: {}) => void;
  onRowMultDelete?: () => void;
  selectedRows?: any[];
  metaInfoByRule: any;
  tableWithRef: any;
}

const ToolBarRender: React.FC<ToolBarRenderProps> = (props) => {
  const { config, headModuleId, rowId, moduleId, onRowMultDelete, selectedRows = [] } = props;
  const sotreState = useMetaStore();
  const { pageConfig, pageType, utils, moduleList } = sotreState;
  const { values, realoadValue } = useValuesStore();

  const topFreeBtns = useMemo(() => {
    const extraButtonList = pageConfig?.freeBtnConfig?.filter((config: Record<string, any>) => config?.position == 'module') ?? [];
    return extraButtonList
      .filter((item) => item['position-direction'] === 'top')
      .filter((item) => item['position-module'] === config.props.moduleID);
  }, [pageConfig?.freeBtnConfig, config]);
  
  const topTableBtns = useMemo(() => {
    const extraButtonList = pageConfig?.topTableBtnConfig?.filter((config: Record<string, any>) => config?.position == 'module') ?? [];
    return extraButtonList
      .filter((item) => item['position-module'] === config.props.moduleID);
  }, [pageConfig?.topTableBtnConfig, config]);


  const createBtns = () => {
    if (pageType === 'view' || config.props?.hideListAdd || config.props?.fileConfig?.fileModule) {
      return null;
    }
    return (
      <RuleController id={`${config.props.moduleID}.add-btns`}>
        <span style={{ marginRight: '8px' }}>
          <Button type="primary" ghost onClick={() => props.addTableData(config.props.moduleID)}>
            <PlusOutlined /> {pageConfig?.pageModuleConfig?.[moduleId]?.addButtonText || '新建'}
          </Button>
        </span>
      </RuleController>
    );
  };

  const btnsClick = (val: FreeBtnClickProps) => {
    props.freeButtonClick(val, {
      headValue: values?.[headModuleId]?.find((item) => item._id === rowId) || {}, selectedRows,
    });
  };

  return (
    <>
      {createBtns()}
      <TopTableBtns allData={values} btnInfo={topTableBtns} metaInfoByRule={props.metaInfoByRule} addTableDataList={props.addTableDataList} addTableData={props.addTableData} moduleID={config.props.moduleID} moduleList={moduleList} />
      {config.props?.selectType === TableRowSelectType.Checkbox && config.props?.rowMultDelete &&
        <Button onClick={onRowMultDelete} disabled={!selectedRows || selectedRows.length === 0}>
          <DeleteOutlined /> 批量删除
        </Button>
      }
      &nbsp;&nbsp;
      <SpBusinessBtns
        utils={{ ...utils, reload: realoadValue }}
        btnInfo={topFreeBtns}
        btnsClick={btnsClick}
        moduleID={config.props.moduleID}
        metaInfoByRule={props.metaInfoByRule}
        addTableDataList={props.addTableDataList}
        addTableData={props.addTableData}
        tableWithRef={props.tableWithRef}
      />
    </>
  );
};


ToolBarRender.displayName = 'ToolBarRender';

export default ToolBarRender;

